import { getSyncMessage } from "../shared/sync";

export const sync = {
    getSyncMessage
}